import React, {Component} from "react";

class ProductAutoComplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSuggestions: false,
      ItemsList: props.items || [],
      filteredSuggestions: [],
      searchName: "",
      itemId: "",
      activeSuggestion: 0,
    };
    this.myRef = React.createRef();
    this.autoCompleteInput = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handelOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handelOutsideClick);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ searchName: this.props.value });
    }
  }
  handelOutsideClick(event) {
    if (this.myRef && !this.myRef.current.contains(event.target)) {
      this.setState({ showSuggestions: false });
    }
  }

  onChange = (e) => {
    const searchName = e.currentTarget.value;
    const ItemsList = this.state.ItemsList;
    const searchFilter = ItemsList.filter(
      (itm) =>
        itm.name.toLowerCase().indexOf(searchName.toLowerCase()) >= 0 ||
        itm.id.toLowerCase().indexOf(searchName.toLowerCase()) >= 0 ||
        itm.barcode === searchName
    );
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: searchFilter,
      showSuggestions: true,
      searchName: searchName,
    });
  };
  onClick = (e, item = false) => {
    this.setState({
      searchName: e.currentTarget.innerText,
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
    });
    this.props.action && this.props.action(item);
  };
  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;
    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        searchName: filteredSuggestions[activeSuggestion].name,
      });
      this.props.action &&
        this.props.action(filteredSuggestions[activeSuggestion]);
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        searchName,
      },
    } = this;
    let suggestionsListComponent;

    if (showSuggestions && searchName) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <div className="tt-menu tt-open">
            {filteredSuggestions.map((itm, index) => {
              let className = "";

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = "bg-secondary";
              }
              return (
                <div
                  onClick={(e) => onClick(e, itm)}
                  className={`tt-suggestion tt-selectable ${className}`}
                  key={index}
                >
                  <h6>{itm.name}</h6>
                </div>
              );
            })}
          </div>
        );
      } else {
        suggestionsListComponent = (
          <div className="tt-menu tt-open text-center">
            <h6 className="pt-3">No suggestions, you're on your own!</h6>
          </div>
        );
      }
    }

    let placeHolder = this.props.placeHolder;
    if (this.props.default) {
      this.setState({ searchName: "" });
      this.props.defaultFallback();
      this.myRef.current.focus();
    }

    return (
      <div className="input-group">
        <input
          ref={this.myRef}
          type="text"
          className="input-sm form-control"
          autoComplete="off"
          placeholder={placeHolder}
          required
          autoFocus={true}
          name={this.props.name}
          value={searchName}
          onKeyDown={onKeyDown}
          onChange={onChange}
        />
        {suggestionsListComponent}
      </div>
    );
  }
}
export default ProductAutoComplete;
